const READING_LINE = 120;

/**
 * @param {number[]} tops each heading's top relative to the viewport, in document order
 * @param {number} line the reading line
 * @returns {number} index of the current section, or -1 before the first one
 */
export function activeSection(tops, line) {
    let active = -1;
    for (let i = 0; i < tops.length; i++) {
        if (tops[i] > line) break;
        active = i;
    }
    return active;
}

function boot() {
    const links = [...document.querySelectorAll('[data-bl-toc] a[href^="#"]')];
    const headings = links.map((a) => document.getElementById(a.getAttribute('href').slice(1)));
    if (links.length === 0 || headings.includes(null)) return;

    let current = null;
    let queued = false;
    const update = () => {
        queued = false;
        const index = activeSection(
            headings.map((h) => h.getBoundingClientRect().top),
            READING_LINE,
        );
        const next = links[index] ?? null;
        if (next === current) return;
        current?.removeAttribute('aria-current');
        next?.setAttribute('aria-current', 'location');
        current = next;
    };

    addEventListener(
        'scroll',
        () => {
            if (!queued) {
                queued = true;
                requestAnimationFrame(update);
            }
        },
        { passive: true },
    );
    update();
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
}
